import { useState } from "react";
import {
    CloseTemplatesView,
    CloseTemplatesViewColumn,
} from "@common/types/views/closeTemplatesView";
import { View, ViewDensity, ViewType } from "@common/types/views/views";
import { Drawer } from "@design-system/Drawer";
import { TablePageHeader } from "@components/pageHeader/TablePageHeader";
import { OrganizationCloseTemplatesList } from "../OrganizationCloseTemplates/OrganizationCloseTemplatesList";

const DRAWER_VIEW: CloseTemplatesView = {
    type: ViewType.CLOSE_TEMPLATES,
    columns: [
        { id: CloseTemplatesViewColumn.NAME, options: { pin: "left" } },
        { id: CloseTemplatesViewColumn.SERVICE },
        { id: CloseTemplatesViewColumn.CLIENT },
        { id: CloseTemplatesViewColumn.BASIS },
        { id: CloseTemplatesViewColumn.OWNER },
        { id: CloseTemplatesViewColumn.NUMBER_OF_TASKS },
        { id: CloseTemplatesViewColumn.UPDATED },
        { id: CloseTemplatesViewColumn.ACTIONS, options: { pin: "right" } },
    ],
    filters: {},
    options: {
        selection: false,
        bulkActions: false,
        density: ViewDensity.MD,
    },
};

const noop = () => undefined;

interface ContentProps {
    taskTemplateId: string;
}

const DrawerContent = ({ taskTemplateId }: ContentProps) => {
    const [search, setSearch] = useState("");
    const [view, setView] = useState<CloseTemplatesView>(DRAWER_VIEW);

    return (
        <>
            <TablePageHeader
                isFullPage
                search={search}
                onSearchChange={setSearch}
            />
            <OrganizationCloseTemplatesList
                search={search}
                archiveFilter="active"
                sourceTaskTemplateIds={[taskTemplateId]}
                view={view}
                onViewChange={(newView: View) =>
                    setView(newView as CloseTemplatesView)
                }
                hasActiveFilters={search !== ""}
                onClearFilters={() => setSearch("")}
                onCreateTemplate={noop}
            />
        </>
    );
};

interface Props {
    taskTemplateId: string | null;
    taskTemplateName: string | null;
    onClose: () => void;
}

export const OrganizationTaskTemplateServiceTemplatesDrawer = ({
    taskTemplateId,
    taskTemplateName,
    onClose,
}: Props) => (
    <Drawer
        open={taskTemplateId !== null}
        onClose={onClose}
        direction="right"
        size="fullScreen"
        noPadding
        headerAddonLeft={
            taskTemplateName
                ? `Service templates · ${taskTemplateName}`
                : "Service templates"
        }
    >
        {taskTemplateId && <DrawerContent taskTemplateId={taskTemplateId} />}
    </Drawer>
);
